import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-dismiss',
  templateUrl: './icon-dismiss.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconDismissComponent {}
